import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { fetchWithToken } from "../../apiUtils";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
}));

const DevPortal = () => {
  const classes = useStyles();
  const [inputValue, setInputValue] = useState("");
  const [response, setResponse] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();

    fetchWithToken(`api/functionApp/${inputValue}`, "POST")
      .then((response) => response.text())
      .then((data) => setResponse(data));

    // Handle form submission here, e.g., submit the input value to an API
    console.log("Submitted value:", inputValue);
    // Reset input value after submission
    setInputValue("");
  };

  const handleChange = (event) => {
    setInputValue(event.target.value);
  };

  return (
    <>
      <form
        className={classes.root}
        noValidate
        autoComplete="off"
        onSubmit={handleSubmit}
      >
        <div>
          <TextField
            id="outlined-basic"
            label="Enter your name"
            variant="outlined"
            value={inputValue}
            onChange={handleChange}
          />
        </div>
        <div>
          <Button variant="contained" color="primary" type="submit">
            Submit
          </Button>
        </div>
      </form>
      <br />
      <h1>{response}</h1>
    </>
  );
};
export default DevPortal;
